<template>
  <div class="honor-system">
    <h3>{{ title }}</h3>
    <JourneyMedia v-if="media" :media="media"/>
    <div class="description">
      <span v-html="description"></span>
    </div>
    <action-button
      class="link-button"
      :busy="submitting"
      v-if="!stepCompleted"
      @click="markAsComplete"
      @keyup.enter="markAsComplete"
    >
      {{ buttonText }}
    </action-button>
    <span
      class="undo"
      v-if="canUndo"
      @click="markAsIncomplete"
      @keyup.enter="markAsIncomplete"
    >
      {{ $t("message.undo") }}
    </span>
  </div>
</template>

<style lang="less" scoped>
@import "./shared.less";
.honor-system {
  .description {
    display: flex;
  }
  .undo {
    text-decoration: underline;
    padding-top: 1em;
    display: inline-flex;
    color: #e9e9e9;
  }
  button {
    background: gray;
    color: white;
    cursor: pointer;
    &:hover {
      background: lighten(gray, 10%) !important;
    }
  }
}
</style>

<script>
import axios from "axios";
import { mapActions } from "vuex";
import ActionButton from "@/common/components/ActionButton";
import JourneyMedia from "./JourneyMedia";

export default {
  components: { ActionButton, JourneyMedia },
  props: {
    description: {
      type: String,
    },
    title: {
      type: String,
    },
    buttonText: {
      type: String,
    },
    started: {
      type: Boolean,
      default: false,
    },
    completed: {
      type: Boolean,
      default: false,
    },
    stepId: {
      type: Number,
    },
    media: {
      type: Object,
    },
  },
  data() {
    return {
      stepCompleted: null,
      canUndo: null,
      submitting: false,
    };
  },
  mounted() {
    this.stepCompleted = this.completed;
  },
  methods: {
    markAsComplete() {
      if (!this.started) {
        this.promptStartJourney();
        return false;
      }
      if (this.submitting) {
        return false;
      }
      this.submitting = true;
      axios
        .post(`/api/journeys/honor-step/${this.stepId}`)
        .then((response) => {
          this.$emit("update");
          this.stepCompleted = true;
          this.canUndo = true;
          // Allow user to undo for up to 3 minutes
          setTimeout(() => {
            this.canUndo = false;
          }, 180000);
          this.submitting = false;
          if (window.reloadHomeContent) {
            window.reloadHomeContent();
          }
        })
        .catch((error) => {
          console.log(error);
          this.submitting = false;
        });
    },
    markAsIncomplete() {
      if (this.submitting) {
        return false;
      }
      this.submitting = true;
      axios
        .delete(`/api/journeys/honor-step/${this.stepId}`)
        .then((response) => {
          this.$emit("update");
          this.stepCompleted = false;
          this.canUndo = false;
          this.submitting = false;
          if (window.reloadHomeContent) {
            window.reloadHomeContent();
          }
        })
        .catch((error) => {
          console.log(error);
          this.submitting = false;
        });
    },
    ...mapActions(["promptStartJourney"])
  },
};
</script>
